import {
  AccessToken,
  GetKeepLogin,
  GetTimezoneOffset,
  MerchantId,
  RemoveCookiesToken,
  SetCookiesAccessToken,
  SetCookiesRefreshToken,
} from "@/helper/authenticationHelper";
import { i18n } from "@/i18n";
import API from "@/service/Index";
import axios from "axios";

let isRefreshing = false;
let failedQueue = [] as any;

const ProcessQueue = () => {
  const token = AccessToken();
  if (token && failedQueue.length > 0) {
    failedQueue.forEach((prom: any) => {
      prom.resolve();
    });
  }
  failedQueue = [];
};

const ReSendApiByNewAccessToken = (originalConfig: any) => {
  const token = AccessToken();
  originalConfig.headers["Authorization"] = "Bearer " + token;
  return axios(originalConfig)
    .then((resCallback) => {
      return resCallback;
    })
    .catch(() => {
      console.log("ReSendApiByNewAccessToken Error;");
    });
};

const CreateAxiosInstance = (baseURL: string) => {
  const instance = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    },
  });

  instance.interceptors.request.use(
    (config) => {
      const token = AccessToken();
      const merchantId = MerchantId();
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      if (merchantId) {
        config.headers["merchantId"] = `${merchantId}`;
      }
      config.headers["language"] = i18n.locale;
      config.headers["timezoneOffset"] = GetTimezoneOffset();

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  instance.interceptors.response.use(
    (res) => {
      return res;
    },
    (err) => {
      const originalConfig = err.config;
      if (err.response && err.response.status === 401) {
        // Access Token was expire
        if (isRefreshing) {
          return new Promise((resolve) => {
            failedQueue.push({ resolve });
          }).then(() => {
            return ReSendApiByNewAccessToken(originalConfig);
          });
        }

        isRefreshing = true;

        return API.AuthenService.DoGetNewAccessTokenByRefreshToken()
          .then((resNewAccessTokenByRefreshToken) => {
            if (resNewAccessTokenByRefreshToken.status.IsSuccess()) {
              const keepLogin = GetKeepLogin();
              SetCookiesAccessToken(resNewAccessTokenByRefreshToken.data.access_token);
              SetCookiesRefreshToken(resNewAccessTokenByRefreshToken.data.refresh_token, keepLogin);
              return ReSendApiByNewAccessToken(originalConfig);
            }
          })
          .catch((_error) => {
            RemoveCookiesToken();
          })
          .finally(() => {
            ProcessQueue();
            isRefreshing = false;
          });
      }

      return Promise.reject(err);
    }
  );
  return instance;
};

const peakExportAPI = CreateAxiosInstance(process.env.VUE_APP_PeakExportService);
const peakReportAPI = CreateAxiosInstance(process.env.VUE_APP_PeakExportServiceForReport);
const peakRealTimeAPI = CreateAxiosInstance(process.env.VUE_APP_PeakRealTimeService);
const peakRealTimeAPIForUser = CreateAxiosInstance(process.env.VUE_APP_PeakRealTimeServiceForUser);
const peakDocumentAPI = CreateAxiosInstance(process.env.VUE_APP_PeakPayrollService);
const peakAuthen = CreateAxiosInstance(process.env.VUE_APP_PeakAuthenService);
const peakAppConnect = CreateAxiosInstance(process.env.VUE_APP_PeakAppConnectService);
const peakPDFLog = CreateAxiosInstance(process.env.VUE_APP_PeakPDFLogService);
const peakOnlineView = CreateAxiosInstance(process.env.VUE_APP_PeakOnlineViewService);

export default {
  peakExportAPI,
  peakRealTimeAPI,
  peakDocumentAPI,
  peakAuthen,
  peakReportAPI,
  peakAppConnect,
  peakPDFLog,
  peakOnlineView,
  peakRealTimeAPIForUser,
};
